import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getBrowserRegistrationSettings} from 'src/openapi/admin/apis/GetBrowserRegistrationSettingsApi';
import {saveBrowserRegistrationSettings} from 'src/openapi/admin/apis/SaveBrowserRegistrationSettingsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';
import type {BrowserRegistrationSettings} from 'src/openapi/admin/models/BrowserRegistrationSettings';

type Props = {
    userId: number,
};

export const useUserBrowserLimits = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => (
        apiDispatch(getBrowserRegistrationSettings({userId}, {signal}))
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((
        browserRegistrationSettings: BrowserRegistrationSettings,
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(saveBrowserRegistrationSettings({
        userId,
        browserRegistrationSettingsSaveRequest: {...browserRegistrationSettings, reason: options?.reason},
    }, {signal})), [userId, apiDispatch]);

    return useCommonDataHook({
        initValue: {
            registrationEnforced: false,
            maxAllowedPlaces: 0,
        },
        getDispatchAction,
        saveDispatchAction,
    });
};
